module.exports = __webpack_public_path__ + "img/summary-alert.2b0576f7.png";